module.exports = __webpack_public_path__ + "img/shot_img20030601.1c7bdecf.gif";